export const LIST_BLOCK_SEP: string = "\n\n---\n\n"

function normalizeListLine(line: unknown): string {
  return String(line).replace(/^[-•]\s*/, "").trim()
}

export function joinListBlocks(arr: unknown[] | null | undefined): string {
  if (!Array.isArray(arr)) return ""
  return arr.map((line) => normalizeListLine(line)).filter(Boolean).join(LIST_BLOCK_SEP)
}

export function splitListBlocks(text: string): string[] {
  if (!text || !String(text).trim()) return []
  return String(text)
    .split(/\n\s*---\s*\n/)
    .map((l) => normalizeListLine(l))
    .filter(Boolean)
}
